import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, TrendingUp, Coins, Wallet, User } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const BottomNav = () => {
  const location = useLocation();
  const { user } = useAuth();
  
  // Check if on vendor route
  if (location.pathname.startsWith('/vendor')) {
    return null;
  }
  
  // Check if user is vendor
  const userType = localStorage.getItem('userType');
  if (userType === 'vendor') {
    return null;
  }
  
  // Check if a path is active
  const isActive = (path) => {
    return location.pathname === path;
  };
  
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex justify-between items-center p-3 z-10">
      <NavItem 
        to="/home"
        icon={<Home size={24} />}
        label="Home"
        active={isActive('/home')}
      />
      <NavItem 
        to="/deals"
        icon={<TrendingUp size={24} />}
        label="Deals"
        active={isActive('/deals')}
      />
      <NavItem 
        to="/earn"
        icon={<Coins size={24} />}
        label="Earn"
        active={isActive('/earn')}
      />
      <NavItem 
        to="/wallet"
        icon={<Wallet size={24} />}
        label="Wallet"
        active={isActive('/wallet')}
      />
      <NavItem 
        to="/profile"
        icon={<User size={24} />}
        label="Profile"
        active={isActive('/profile')}
      />
    </div>
  );
};

// Individual navigation item component
const NavItem = ({ to, icon, label, active }) => {
  return (
    <Link to={to} className="flex flex-col items-center">
      <div className={`${active ? 'text-blue-600' : 'text-gray-500'}`}>
        {icon}
      </div>
      <div className={`text-xs mt-1 ${active ? 'text-blue-600 font-medium' : 'text-gray-500'}`}>
        {label}
      </div>
    </Link>
  );
};

export default BottomNav;